import styled, { css } from 'styled-components';
interface ItemProps {
  readonly color?: string;
  readonly size?: string;
  readonly margin?: string;
  readonly mBottom?: string;
  readonly alignItems?: string;
  readonly minHeight?: string;
}

export const PlayersContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  overflow-x: unset;
  padding-bottom: 250px;
  margin-bottom: -242px;
`;

export const ContainerLeft = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start; /* align items to top */
  width: 60%;
  flex-wrap: wrap; /* allow wrapping on smaller screens */
  gap: 8px; /* modern gap instead of margins */

  /* Mobile - stack vertically */
  flex-direction: column;

  /* Tablet and up - horizontal layout */
  @media (min-width: 950px) {
    flex-direction: row;
    flex-wrap: nowrap; /* prevent wrapping on larger screens */
    gap: 0; /* use DropdownWrapper margins instead */
  }
`;

export const ContainerRight = styled.div`
  display: inline-flex;
  justify-content: flex-end;
  align-items: center;
`;

export const DropdownWrapper = styled.div`
  /* Mobile first */
  width: 100%;

  /* The PowerDropdown fixed width (308px) might be too wide for mobile */
  & > * {
    width: 100%;
    max-width: 100%;
  }

  @media (min-width: 768px) {
    width: auto;
    margin: 5px 10px;

    &:first-of-type {
      margin-left: 0;
    }

    /* Allow PowerDropdown to use its fixed width on larger screens */
    & > * {
      width: auto;
      max-width: none;
    }
  }
   /* Add this for the MessageText wrapper specifically */
  &:has(p), /* if browser supports :has() */
  &.message-wrapper {
    display: flex;
    align-items: center;
    min-height: 48px; /* match height of other dropdowns */
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  margin-left: 10px;
  flex-direction: row;
  justify-content: space-between;

  &:last-of-type {
    margin-right: 0;
  }
`;

export const TabContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
  min-height: 67px;
  align-items: center;
`;

export const PerforemaceContainer = styled.div`
  justify-content: center;
  align-items: center;
  margin-left: auto;
  display: flex;
`;

export const PerforemaceTitle = styled.span`
  color: var(--DarkGray);
  margin-right: 10px;
  font-size: 14px;
`;
export const TabButtons = styled.div`
  display: flex;
  justify-content: center;
`;
export const BoxInfoWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
`;

export const TableWrapper = styled.div<ItemProps>`
  display: flex;
  justify-content: center;
  width: 100%;
  min-height: ${props => (props.minHeight ? props.minHeight : 'auto')};
  @media (max-width: 1400px) {
    overflow-x: auto;
    justify-content: flex-start;
  }
`;

export const ExamRadios = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const RadiosWrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;

`;

export const RadiosContainer = styled.div<ItemProps>`
  justify-content: center;
  align-items: flex-start;
  margin-bottom: ${props => (props.mBottom ? props.mBottom : '15px')};
  display: flex;
  width: fit-content;

  & > span {
    color: #5d6e81;
    font-size: 14px;
  }
`;
export const NavContainerPlayers = styled.div`
  display: grid;
  grid-template-columns: 1fr repeat(3, auto) 1fr;
  grid-column-gap: 5px;
  justify-items: center;
  margin-bottom: 15px;
  min-width: 125px;

  & > span {
    color: #5d6e81;
    font-size: 14px;
  }
  & > :first-child {
    grid-column-start: 4;
  }
`;

export const RadiosWrapper = styled.div<ItemProps>`
  display: flex;
  justify-content: center;
  flex-direction: column;
  position: sticky;
  z-index: 2 !important;
  top: 0;
  min-height: 100px;
  background-color: var(--BackgroundGray);
  padding-bottom: 24px;
  padding-top: 24px;
  ${props => `align-items:${props.alignItems};`}
`;

export const PlayersDataSection = styled.section`
  background-color: var(--BackgroundGrey);
  padding-top: 40px;
`;

export const PlayersFilterSection = styled.div`
  justify-content: space-between;
  white-space: nowrap;
  overflow-x: auto;
  display: flex;
`;

export const EmptyContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ArmRecoveryContainer = styled.div`
  box-sizing: border-box;
  height: 41px;
  width: 250px;
  position: relative;
  align-self: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 25px 0;
`;
export const RomContainer = styled.div`
  box-sizing: border-box;
  height: 41px;
  width: 250px;
  position: relative;
  align-self: flex-start;
  margin-left: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const Oval = styled.div<ItemProps>`
  border-radius: 50% 50% 50% 50%;
  display: inline-block;
  margin-left: auto;
  ${props => {
    const height = 'min-height:' + props.size + 'px;height:' + props.size + 'px;';
    const width = 'min-width:' + props.size + 'px;width:' + props.size + 'px;';
    const margin = 'margin:' + props.margin + ';';
    let color;
    let case1 = ['watch', 'zone 1', 'Sore'];
    let case2 = ['warning', 'zone 2'];
    let case3 = ['medical', 'zone 3'];
    let case4 = ['Pain'];
    if (case1.some(elem => elem === props.color)) {
      color = 'rgba(255,191,86,1)';
    } else if (case2.some(elem => elem === props.color)) {
      color = 'rgba(228,146,255,1)';
    } else if (case3.some(elem => elem === props.color)) {
      color = 'rgba(0,155,158,1)';
    } else if (case4.some(elem => elem === props.color)) {
      color = '#FF5E55';
    } else if (props.color === 'white') {
      color = '#F7F8FA';
    } else {
      color = 'none';
    }
    if (color !== 'none') {
      const background = 'background:' + color + ';';
      return css`
         {
          ${height}
          ${width}
          ${background}
          ${margin}
        }
      `;
    }
    return css`
       {
        ${height}
        ${width}
     ${margin}
      }
    `;
  }};
`;
export const TextContainer = styled.div`
  color: rgba(93, 110, 129, 1);
  font-family: 'Proxima Nova';
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.61px;
  display: inline-flex;
`;
export const AlertContainer = styled.div`
  width: 50%;
  display: inline-block;
  color: rgba(93, 110, 129, 1);
  font-family: 'Proxima Nova';
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.55px;
  line-height: 9px;
  align-items: center;
`;

export const AlertWrapper = styled.div`
  display: inline-flex;
  width: 100%;
  align-self: center;
  padding-left: 2px;
`;

export const ExamInfoContainer = styled.div`
  justify-content: space-between;
  align-items: center;
  display: flex;

  @media (max-width: 800px) {
    overflow-x: auto;

    & > div {
      margin: 0 20px 0 20px;
      white-space: nowrap;
      min-width: 190px;
    }
  }
`;

export const ExamInfoUnit = styled.div`
  display: flex;
  align-items: center;
  min-width: 180px;

  & > span:first-of-type {
    margin-right: 10px;
    color: #5d6e81;
    font-size: 14px;
  }
`;

export const ExamTopNav = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  overflow-x: auto;
`;

export const ArmRecoveryTop = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-bottom: 12px;
`;

export const ArmRecoveryInfoButton = styled.div`
  height: 18px;
  width: 18px;
  border-radius: 50%;
  margin-left: 8px;
  background-color: rgba(172, 177, 192, 0.5);
  text-align: center;
  color: white;
  cursor: pointer;
`;
export const ArmRecoveryInfoTitle = styled.p`
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  margin: 0px;
  color: black;
`;

export const ArmRecoveryInfoSubtitle = styled.p`
  font-size: 16px;
  font-weight: normal;
  text-align: center;
  margin-top: 0px;
  color: #5d6e81;
`;

export const ArmRecoveryInfoText = styled.p`
  font-size: 16px;
  font-weight: normal;
  text-align: justify;
  color: #5d6e81;
`;

export const ArmRecoveryInfoSpan = styled.span`
  font-weight: bold;
`;

export const ArmRecoveryInfoSection = styled.h1`
  color: #43484f;
  font-weight: bold;
  margin-bottom: 0px;
`;
interface ModalProps {
  readonly hide?: boolean;
  readonly marginBottom?: string;
}

export const ModalTop = styled.div`
  border-radius: 8px 8px 0px 0px;
  padding: 20px 40px;
`;

export const ModalDivArrow = styled.div`
  min-width: 20px;
  max-width: 20px;
  font-size: 32px;
  color: #acb1c0;
  cursor: pointer;
`;

export const ModalTopText = styled.div`
  border-top: 1px solid #fcfcfc;
  padding: 20px 40px;
  color: #5d6e81;
  text-align: justify;
  font-size: 16px;
`;

export const ModalH1 = styled.h1<ModalProps>`
  color: #43484f;
  font-weight: bold;
  ${props => 'margin-bottom:' + props.marginBottom};
`;

export const ModalSpan = styled.span`
  font-weight: bold;
`;
export const ModalBottom = styled.div`
  background-color: #fcfcfc;
  border-top: 1px solid #e7e9ec;
  padding: 20px 40px;
  border-radius: 0px 0px 8px 8px;
`;

export const ModalBottomLabels = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100;
  font-size: 12px !important;
  font-weight: bold !important;
  padding-bottom: 12px;
`;

export const KeyMetricsGraphic = styled.div`
  & > .plot-container .svg-container svg {
    border-radius: 13px;
    box-sizing: border-box;
    border: 1px solid #E6E7E9;
  }
`;

export const FilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const ContainerDropdown = styled.div`
  width: 156px;
`;

export const WrapperFilter = styled.div`
  height: 45px;
  display: flex;
  margin-top: 23px;
  margin-bottom: 16px;
  align-items: center;
  flex-direction: row;
`;

export const MiddleText = styled.span`
  color: #5D6E81;
  margin: 0 16px;
  font-size: 15px;
  font-weight: 300;
  text-align: center;
  line-height: 14.3px;
  letter-spacing: 0.1px;
  text-align: center;
  font-family: "Proxima Nova";
`;

export const MiddleTextStrong = styled.span`
  color: #5D6E81;
  font-size: 15px;
  font-weight: 500;
  text-align: center;
  line-height: 14.3px;
  letter-spacing: 0.1px;
  text-transform: uppercase;
  font-family: "Proxima Nova Semibold";
`;

export const MessageText = styled.p`
  height: 100%;
  color: #5D6E81;
  margin: auto 1px;
  font-size: 16px;
  font-family: "Proxima Nova";
  @media (max-width: 767px) {
    text-align: center;
    padding: 12px 16px;
    border-radius: 4px;
  }
`;


